module.exports = __webpack_public_path__ + "static/media/BreathingTechniquesGREEK.ce5a56b8.vtt";